export class LinkedBlock {
    FirstLinkedBlockName: string;
    FirstLinkedBlockId: string;

    SecondLinkedBlockName: string;
    SecondLinkedBlockId: string;
}
